<template>
  <div>
    <ProgressBar :max="totalSteps" :value="currentStep" :content="progressContent" class="sticky top-0" />
    <RouteStepper
      class="w-full mt-32 md:mt-60 md:max-w-[568px] px-16 mx-auto"
      :hideBreadcrumb="true"
      @progress="onProgress"
      @submit="redirectToAccountCreation"
    />
  </div>
</template>

<script lang="ts">
import RouteStepper from '@/components/route_stepper/RouteStepper.vue';
import ProgressBar from '@/components/progress_bar/ProgressBar.vue';
import { OnboardingSeekerDraft } from './types';
import { redirect } from '@/helpers/redirects';

export default {
  name: 'OnboardingSeeker',
  components: { RouteStepper, ProgressBar },
  data(): { currentStep: number; totalSteps: number } {
    return {
      currentStep: 1,
      totalSteps: 1,
    };
  },
  computed: {
    progressContent(): string {
      return `Step ${this.currentStep} of ${this.totalSteps}`;
    },
  },
  methods: {
    redirectToAccountCreation({ zipCode }: OnboardingSeekerDraft): void {
      const params = new URLSearchParams({ member_type: 'seeker', skip_onboarding: 'true' });
      if (zipCode) {
        params.set('zip_code', zipCode);
      }
      redirect(`/registration?${params.toString()}`);
    },
    onProgress({ currentStep, totalSteps }: { currentStep: number; totalSteps: number }): void {
      this.currentStep = currentStep;
      this.totalSteps = totalSteps;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .card:not(.card-preserve) {
  padding: 24px;

  @media (max-width: 640px) {
    background-color: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
}
</style>
